var ModelActionsMixin = {
    data() {
        return {
            modelData: null,
            parentView: null,
            modelIdColumn: 'id',
            alwaysUpdate: false, // If set to true, the model change will alwasy be updateModel()
        }
    },

    mounted() {
        this.listenModelActionsMixinEvents();
    },

    methods: {
        /**
         * Determine what actions should be executed on the model.
         */
        handleModelChange() {
            if (!this.hasModel && !this.modelFilled) {
                // Emit the update event if nothing happened, otherwise the loading status will not disappear
                this.emitModelUpdatedEvent();
                return;
            }

            if (!this.hasModel && this.modelFilled) {
                this.storeModel();
                return;
            }

            if (this.hasModel && this.modelFilled || this.alwaysUpdate) {
                this.updateModel();
                return;
            }

            if (this.hasModel && !this.modelFilled) {
                this.deleteModel();
                return;
            }
        },

        /**
         * Request a model change (store, update or delete).
         */
        requestModelChange() {
            let eventName = this.parentView + ':updateRequested';
            Event.$emit(eventName);
        },

        listenModelActionsMixinEvents() {
            // Listen when the model change is triggered
            let handleModelChangeEvent = this.parentView + ':change';
            Event.$on(handleModelChangeEvent, () => {
                this.handleModelChange();
            });
        },

        /**
         * It emits the event that informs the parent view that the model was loaded.
         */
        emitModelLoadedEvent() {
            let eventName = this.parentView + ':loaded';
            let source = this.modelData;

            Event.$emit(eventName, source);
        },

        /**
         * Reset the validated inputs of the model.
         */
        resetModel() {
            for (var i = 0; i < this.validatedInputs.length; i++) {
                let index = this.validatedInputs[i];
                this[this.modelData][index] = null;
            }

            if (typeof this[this.modelData]['id'] !== 'undefined') {
                this[this.modelData]['id'] = null;
            }
        },

        emitModelUpdatedEvent(successful = true) {
            let eventName = this.parentView + ':updated';
            let source = this.modelData;

            Event.$emit(eventName, source, successful);
        },
    },

    computed: {
        /**
         * Check if the model exists. It exists if has an id which is not null.
         */
        hasModel() {
            if (this.modelData == null) {
                throw new Error("modelData not defined. ModelActionsMixin can't work without it.");
            }

            if (this.parentView == null) {
                throw new Error("parentView not defined. ModelActionsMixin can't work without it.");
            }

            return this[this.modelData][this.modelIdColumn] !== null;
        },

        /**
         * Check if the model is filled. It is considered filled if at least one of the model columns is not null.
         */
        modelFilled() {
            if (!this.hasOwnProperty('validatedInputs')) {
                throw new Error("porperty validatedInputs is not defined. Check if FormErrors mixin was added to the component.");
            }

            if (!this.validatedInputs instanceof Array) {
                throw new Error("property validatedInputs must be an array.");
            }

            for (var i = 0; i < this.validatedInputs.length; i++) {
                let dataIndex = this.validatedInputs[i];

                if (this[this.modelData][dataIndex]) {
                    // We found at least one property which is not empty, this means that the model is filled
                    return true;
                }
            }

            return false;
        },
    },
}

export default ModelActionsMixin;
